import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";

import usePartenairesManager from "./hooks/usePartenairesManager";

import PartenaireStats from "./components/PartenaireStats";
import PartenaireToolbar from "./components/PartenaireToolbar";
import PartenaireTable from "./components/PartenaireTable";
import PartenaireFormDrawer from "./components/PartenaireFormDrawer";

export default function Partenaires() {
  useScrollToTop();

  const {
    loading,
    saving,
    stats,
    query,
    statusFilter,
    visiblePartenaires,
    filteredPartenaires,
    visibleCount,
    drawer,
    demoMode,

    setQuery,
    setStatusFilter,
    resetFilters,
    loadMore,
    refreshData,

    openCreateDrawer,
    openEditDrawer,
    closeDrawer,
    handleCreatePartenaire,
    handleUpdatePartenaire,
    handleDeletePartenaire,
  } = usePartenairesManager();

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <PartenaireToolbar
          query={query}
          statusFilter={statusFilter}
          loading={loading}
          demoMode={demoMode}
          onQueryChange={setQuery}
          onStatusChange={setStatusFilter}
          onReset={resetFilters}
          onRefresh={refreshData}
          onCreate={openCreateDrawer}
        />

        <PartenaireStats stats={stats} />

        <PartenaireTable
          partenaires={visiblePartenaires}
          loading={loading}
          totalRows={filteredPartenaires.length}
          visibleCount={visibleCount}
          demoMode={demoMode}
          onLoadMore={loadMore}
          onEdit={openEditDrawer}
          onDelete={handleDeletePartenaire}
        />
      </div>

      <PartenaireFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        saving={saving}
        onClose={closeDrawer}
        onCreate={handleCreatePartenaire}
      />

      <PartenaireFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        partenaire={drawer.partenaire}
        saving={saving}
        onClose={closeDrawer}
        onUpdate={handleUpdatePartenaire}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
}